(() => {
  const form = document.getElementById('TarbiyahWithdrawal');
  if (!form) return;
  const key = 'tarbiyah-withdrawal-confirmation';
  form.addEventListener('submit', () => {
    const submittedAt = new Date().toISOString();
    const timestamp = form.querySelector('#WithdrawalTimestamp');
    if (timestamp) timestamp.value = submittedAt;
    const data = new FormData(form);
    const receipt = {
      order: String(data.get('contact[Bestelnummer]') || ''),
      products: String(data.get('contact[body]') || ''),
      email: String(data.get('contact[email]') || ''),
      submittedAt,
    };
    try { sessionStorage.setItem(key, JSON.stringify(receipt)); } catch { /* The form also works without browser storage. */ }
  });
  const success = form.querySelector('[data-withdrawal-success]');
  if (!success) return;
  let receipt;
  try { receipt = JSON.parse(sessionStorage.getItem(key)); } catch { /* Show the server confirmation. */ }
  const confirmedAt = new Date(receipt?.submittedAt || Date.now()).toLocaleString('nl-NL', {timeZone:'Europe/Amsterdam',timeZoneName:'short'});
  const confirmation = [
    'Tarbiyah Kids — Bevestiging herroeping',
    'Ontvangen: ' + confirmedAt,
    'Bestelnummer: ' + (receipt?.order || 'Zie je ingediende verzoek'),
    'Aankoop: ' + (receipt?.products || 'Zie je ingediende verzoek'),
    'E-mail: ' + (receipt?.email || ''),
    '',
    'Je herroeping is ontvangen. Bewaar deze bevestiging.',
    'Na de melding heb je 14 dagen om de producten terug te sturen.',
    'Vragen: info@tarbiyahkids.nl',
  ].join('\n');
  success.querySelector('[data-withdrawal-receipt]').textContent = 'Je herroeping' + (receipt?.order ? ' voor bestelling ' + receipt.order : '') + ' is ontvangen op ' + confirmedAt + '. Bewaar hieronder de bevestiging.';
  const download = success.querySelector('[data-withdrawal-download]');
  download.href = URL.createObjectURL(new Blob([confirmation], {type:'text/plain;charset=utf-8'}));
  download.download = 'tarbiyah-kids-herroeping.txt';
  download.hidden = false;
})();
